import React from 'react';
import { useState, useEffect } from 'react';
import './home.css'
import './event.css'
import './home.css'
import './../animations.css'

import HeadingBlock from '../components/common/heading';
import Categories from '../sections/categories';
import Button from '../components/common/button';
const Onboarding = () => {
    return ( <>
    <main>
    <div className=" catSec">
        <section className='onboardFlex '>
            <HeadingBlock 
        style1="light center decor paddedCont"
        heading="Discover All kinds of Crafts"
        subheading="Explore a world of creativity and culture in one place."
        />
    <Categories />
    <Button
        cta="Get started"
        link="/login"
        style1="blue size1 "
        />
        </section>
    </div>
    </main>
    </> );
}
 
export default Onboarding;